import mutations from './appointmentStatus.mutations'
import actions from './appointmentStatus.actions'
import getters from './appointmentStatus.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}